module.exports = __webpack_public_path__ + "static/media/icn_newsletter.b9244811.svg";